// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"5804db65","213":"39da5197","453":"3d375e85","732":"5b836586"}[chunkId] + ".chunk.js";
};